import { useCallback, useEffect, useMemo, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import {
  getOrganicRankManagementAvailableToAddKeywordsAction,
  removeNewEntityConfigurationItemTemplate,
  replaceTemplateItemByTemporaryEntityConfigurationItem,
  selectEntityConfiguration,
  selectIsOrganicManagementAvailableToAddKeywordsLoading,
  selectOrganicRanksAdditionalInfo,
  selectOrganicRanksAvailableToAddKeywordsData,
} from '../../../../../../../../store/slice/organicRankModal'
import { useOnClickOutside } from '../../../../../../../../utils/hooks/useClickOutside'

export const useListNewItem = ({ id }) => {
  const [searchPhrase, setSearchPhrase] = useState('')
  const [open, setOpen] = useState(false)
  const [anchorEl, setAnchorEl] = useState(null)
  const dropdownRef = useRef()

  const isAvailableListFetching = useSelector(selectIsOrganicManagementAvailableToAddKeywordsLoading)
  const items = useSelector(selectOrganicRanksAvailableToAddKeywordsData)
  const keywordList = useSelector(selectEntityConfiguration)
  const { channelID, productID, accountID } = useSelector(selectOrganicRanksAdditionalInfo)

  const canBeOpen = open && Boolean(anchorEl)
  const popupID = canBeOpen ? 'spring-popper' : undefined

  const filteredItems = useMemo(
    () =>
      items.filter(
        (item) =>
          !keywordList.find(
            (addedItem) => addedItem.type === 'keyword_temp' && addedItem.searchPhrase === item.searchPhrase
          )
      ),
    [items, keywordList]
  )

  const filteredList = useMemo(() => {
    if (!searchPhrase) return filteredItems
    return filteredItems.filter((item) => item.searchPhrase.toLowerCase().includes(searchPhrase.toLowerCase()))
  }, [filteredItems, searchPhrase])

  const dispatch = useDispatch()

  const onFocusInput = (event) => {
    setAnchorEl(event.currentTarget)
    setOpen((previousOpen) => !previousOpen)
  }

  const addTempItem = useCallback(
    (item) => {
      dispatch(replaceTemplateItemByTemporaryEntityConfigurationItem({ id, item }))
    },
    [id]
  )

  const deleteTemplate = useCallback(() => {
    dispatch(removeNewEntityConfigurationItemTemplate(id))
  }, [id])

  const getAvailableList = useCallback(() => {
    dispatch(
      getOrganicRankManagementAvailableToAddKeywordsAction({
        accountID,
        channelID,
        productID,
      })
    )
  }, [productID, accountID, channelID])

  useOnClickOutside(dropdownRef, (e) => {
    e.preventDefault()
    e.stopPropagation()
    setOpen(false)
  })

  useEffect(() => {
    if (open) {
      getAvailableList()
    }
  }, [open])

  return {
    popupID,
    canBeOpen,
    open,
    anchorEl,
    dropdownRef,
    onFocusInput,
    searchPhrase,
    setSearchPhrase,
    deleteTemplate,
    setOpen,
    isAvailableListFetching,
    list: filteredList,
    addTempItem,
  }
}
